export default "__VITE_ASSET__E_XW_Qn6__"